module.exports = __webpack_public_path__ + "img/discover_network_logo.18b48aa.png";